var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgHomeOwner = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home - owner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 18.3334V16.2964C15 15.6579 14.7366 15.0456 14.2678 14.5941C13.7989 14.1426 13.163 13.889 12.5 13.889H7.5C6.83696 13.889 6.20107 14.1426 5.73223 14.5941C5.26339 15.0456 5 15.6579 5 16.2964V18.3334M2.5 7.50008L10 1.66675L17.5 7.50008V16.3334C17.5 17.438 16.6046 18.3334 15.5 18.3334H4.5C3.39543 18.3334 2.5 17.438 2.5 16.3334V7.50008ZM12.5 9.07416C12.5 10.4037 11.3807 11.4816 10 11.4816C8.61929 11.4816 7.5 10.4037 7.5 9.07416C7.5 7.74458 8.61929 6.66675 10 6.66675C11.3807 6.66675 12.5 7.74458 12.5 9.07416Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeOwner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home-owner.f3b8ee5d.svg";
export { ForwardRef as ReactComponent };